<script setup lang="ts">
// globals
defineEmits(['updated:files'])

// stores
const authStore = useAuthStore()
const fileUploaderStore = useFileUploaderStore()

// static
const replaceRegex = /,/g

// refs
const {
  acceptedFiles,
  boxFolder,
  ballotTypes,
  complete,
  processing,
  dialog,
  limit,
  loading,
  headerText,
  useInbox,
  orderId,
  electionId,
} = storeToRefs(fileUploaderStore)

// computed
const { user } = storeToRefs(authStore)
const metadata = computed(() => ({
  ...(electionId.value) && { electionId: electionId.value },
  ...(orderId.value) && { orderId: orderId.value },
  ballotTypes: ballotTypes.value,
  portalUser: user.value?.EmailAddress || '',
}))
const acceptedMessage = computed(() => acceptedFiles.value?.length ? `${acceptedFiles.value.join(', ').replaceAll(replaceRegex, ' / ')} supported` : '')

// methods
const {
  reset,
  updatedFiles,
} = fileUploaderStore
</script>

<template>
  <v-dialog
    v-model="dialog"
    min-height="381px"
    persistent
    width="440px"
  >
    <BaseSheet
      color-header
      dividers
      no-padding
    >
      <template #header>
        <div>
          File Uploader
          <div class="text-subtitle-2">
            {{ headerText }}
          </div>
        </div>
      </template>

      <div class="text-subtitle-2 text-center my-2">
        <strong>* If uploading more than 10 files, upload a .zip file instead</strong><br>
        <strong>File Types:</strong> {{ acceptedMessage }}
      </div>
      <v-divider />
      <BoxContentUploader
        v-model:complete="complete"
        v-model:processing="processing"
        v-model:uploading="loading"
        :accept="acceptedFiles"
        :folder-id="boxFolder"
        inbox-name="Portal"
        :limit="limit"
        :metadata="metadata"
        :use-inbox="useInbox"
        @close="reset"
        @update:complete="$event ? updatedFiles($event) : null"
      />

      <v-overlay
        class="align-center justify-center rounded-lg"
        contained
        :model-value="processing && !complete"
        persistent
      >
        <v-alert>
          <div class="text-center text-subtitle-2 mb-2">
            Finalizing Uploads - Please wait...
          </div>
          <v-progress-linear
            color="primary"
            height="20"
            indeterminate
          />
        </v-alert>
      </v-overlay>
    </BaseSheet>
  </v-dialog>
</template>
